import { render, staticRenderFns } from "./INF.vue?vue&type=template&id=695d3e24&"
import script from "./INF.vue?vue&type=script&lang=js&"
export * from "./INF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('695d3e24')) {
      api.createRecord('695d3e24', component.options)
    } else {
      api.reload('695d3e24', component.options)
    }
    module.hot.accept("./INF.vue?vue&type=template&id=695d3e24&", function () {
      api.rerender('695d3e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/INF.vue"
export default component.exports